import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { ItemCategoriesSelect } from './ItemCategoriesSelect'
import { ItemRisksSelect } from './ItemRisksSelect'
import { ItemTypeField } from './ItemTypeField'
import { usePropertyInsuranceValues } from './PropertyInsuranceContext'
import { formProps } from './utils'

type Props = {
  fieldKey: number
}

export const ItemBasicFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { ItemDescriptionProps, itemsKey, ItemCategoryProps } = formProps(t)
  const { isEditable } = usePropertyInsuranceValues()

  const category = Form.useWatch([
    itemsKey.name,
    fieldKey,
    ItemCategoryProps.name
  ])

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <ItemCategoriesSelect fieldKey={fieldKey} disabled={isEditable} />
      </Col>

      <Col xs={24} md={12}>
        <ItemRisksSelect
          key={`${fieldKey}-${category}`}
          fieldKey={fieldKey}
          category={category?.toUpperCase?.()}
          disabled={!category || isEditable}
        />
      </Col>

      <ItemTypeField
        key={`${fieldKey}-${category}-type`}
        fieldKey={fieldKey}
        category={category?.toUpperCase?.()}
        disabled={isEditable}
      />

      <Col xs={24} md={12}>
        <Form.Item
          {...ItemDescriptionProps}
          name={[fieldKey, ItemDescriptionProps.name]}
        >
          <Input
            placeholder={ItemDescriptionProps.label}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
